<template>
	<div id="app">
		<HeaderComponent />

		<div id="app-content">
			<router-view />
		</div>
	</div>
</template>

<script>
import HeaderComponent from '@/components/HeaderComponent.vue';
import * as user_api from '@/api/user';

export default {
	name: 'App',
	components: {
		HeaderComponent
	},
	created: function() {
		user_api.set_user();
		const redirect = this.$route.query.redirect;
		if (redirect != null) {
			this.$router.push(String(redirect));
		}
	}
};
</script>

<style lang="scss">
#app {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	/*color: #2c3e50;*/
	height: 100vh;
}
body {
	background-size: cover;
	background-position: center;
	background-image: url('./assets/bg.jpg');
}
</style>
